import React from 'react';
import { CheckIcon, ZapIcon, GlobeIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { DECO_COOKIE, OFFER_SUMMARY } from './salesData';

/**
 * PRIMERA revelación del precio de toda la carta. El CTA del hero
 * (#oferta) hace smooth-scroll exactamente hasta acá.
 *
 * La card es deliberadamente compacta: precio en línea, beneficios en dos
 * columnas y el CTA a pocos píxeles del precio.
 */
export function OfferSection() {
  return <section id="oferta" className="relative scroll-mt-24 overflow-hidden bg-[#E9F0D5] py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-192" data-mp="md0dqjema4po">
      <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-193" data-mp="wd9co4zzu48r">
        <div className="flex flex-col items-center text-center" data-id="element-194" data-mp="2t59klghdlooi">
          <SectionTag className="bg-white/70" data-id="element-195" data-mp="2t7454toqjes2">El precio</SectionTag>
          <h2 id="offer-title" className="mt-4 font-display text-[1.95rem] leading-[1.08] text-charcoal sm:text-[2.7rem]" data-id="element-196" data-mp="2y5ffd5ixzrat">
            100 recetas. Un solo pago.
          </h2>
        </div>

        <div className="relative mt-7 rounded-5xl bg-white p-5 shadow-bakery sm:mt-9 sm:p-8" data-id="element-197" data-mp="xv8na5aefbr7">
          {/* Cookie que rompe el borde superior de la card. */}
          <img src={DECO_COOKIE} alt="" aria-hidden loading="lazy" className="absolute -right-4 -top-7 h-[4.5rem] w-[4.5rem] rotate-6 rounded-full object-cover shadow-bakery sm:-right-8 sm:-top-10 sm:h-24 sm:w-24" data-id="element-198" data-mp="owwqflixvhqb" />

          <div className="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-199" data-mp="1clg1u9xacamm">
            <p className="max-w-sm font-display text-[1.08rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-200" data-mp="17nej5q3rudbo">
              100 New York Cookies para fabricar y vender
            </p>
            <div className="flex shrink-0 items-center gap-2" data-id="element-201" data-mp="3scaudb0tbpqg">
              <span className="rounded-full bg-charcoal px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-202" data-mp="3sewzz5457v61">
                Tomo 1
              </span>
              <span className="font-sans text-sm font-bold text-caramel" aria-hidden data-id="element-203" data-mp="2lc4tng8qhe0">
                +
              </span>
              <span className="rounded-full bg-caramel px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-204" data-mp="3oudfa0m4l0fx">
                Tomo 2
              </span>
            </div>
          </div>

          <div className="mt-5 rounded-4xl bg-ivory px-4 py-5 sm:px-6" data-id="element-205" data-mp="3fv03h1aj3zs1">
            <PriceBlock size="lg" data-id="element-206" data-mp="3163locio78e8" />
          </div>

          <div className="mt-5 flex items-baseline gap-3" data-id="element-207" data-mp="313936qj7vxng">
            <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-208" data-mp="365gi9ozcftu0">
              Incluye
            </p>
            <span className="h-px flex-1 bg-warm" aria-hidden data-id="element-209" data-mp="2s70277flcqz7" />
          </div>
          <ul className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-210" data-mp="2x2xixeurnzci">
            {OFFER_SUMMARY.map(item => <li key={item} className="flex items-start gap-2" data-id="element-211" data-mp="2dk1f1onroiqa">
                <span className="mt-[0.2rem] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-pistacho" aria-hidden data-id="element-212" data-mp="28k5j8cp83xlt">
                  <CheckIcon className="h-2.5 w-2.5 text-white" data-id="element-213" data-mp="2ifytfpfgzf0f" />
                </span>
                <span className="font-sans text-[0.84rem] font-medium leading-snug text-charcoal/85" data-id="element-214" data-mp="2wg18z50b1wci">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-215" data-mp="366vv89djwvxy">
            <CTAButton label="Quiero hacer estas cookies" size="lg" className="w-full" data-id="element-216" data-mp="3662y804e9kt0" />

            <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-6 gap-y-1.5" data-id="element-217" data-mp="318uc5og4kwmh">
              <li className="flex items-center gap-1.5 font-sans text-[0.74rem] text-charcoal-mid" data-id="element-218" data-mp="3f82h6xyyyyyl">
                <ZapIcon className="h-3.5 w-3.5 text-caramel" aria-hidden data-id="element-219" data-mp="3a9ip0fts8qxs" /> Acceso digital
                inmediato
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.74rem] text-charcoal-mid" data-id="element-220" data-mp="18h7hlantshj8">
                <GlobeIcon className="h-3.5 w-3.5 text-caramel" aria-hidden data-id="element-221" data-mp="1dfs9mmsxbuwl" /> Conversión a tu
                moneda
              </li>
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center font-sans text-[0.78rem] leading-relaxed text-charcoal-mid" data-id="element-222" data-mp="1m9nbnlyr1580">
          Producto 100% digital: no se envía nada físico. Los resultados de venta dependen de la
          ejecución, la presentación y el mercado de cada persona.
        </p>
      </div>
    </section>;
}